import { api } from '../../../services/api'

export async function disconnectInvoicing() {
  await api.post('/api/me/integrations/invoices/disconnect')
}
